<template>
  <div ref="swiperRef" class="swiper">
    <div class="swiper-wrapper">
      <slot></slot>
    </div>
    <div class="absolute bottom-2 flex h-2 w-full items-center justify-between">
      <slot name="carousel-bullets"></slot>
    </div>
  </div>
</template>

<script setup lang="ts">
  import { computed, onMounted, ref } from 'vue';
  import { Swiper } from 'swiper';
  import { Pagination, Autoplay } from 'swiper/modules';
  import { merge, debounce } from 'lodash-es';
  import type { SwiperOptions } from 'swiper/types';
  import 'swiper/css';

  const props = defineProps<{
    carouselConfig?: SwiperOptions;
  }>();

  const swiperRef = ref();

  const emit = defineEmits<{
    onSwipe: [];
  }>();

  const onSliderMove = debounce(() => emit('onSwipe'), 200);

  const swiperConfig = computed<SwiperOptions>(() =>
    merge(
      {
        init: false,
        spaceBetween: 16,
        pagination: {
          el: '.swiper-pagination',
          dynamicBullets: true,
        },
        on: {
          sliderMove: onSliderMove,
        },
        modules: [Autoplay, Pagination],
        loop: true,
      },
      props.carouselConfig,
    ),
  );

  // Контейнер передаётся первым аргументом, потому что в типах swiper 11 остался
  // только конструктор `(container, options)`. Рантайм игнорирует пустой
  // контейнер, а `init: false` в конфиге всё равно откладывает инициализацию до
  // `swiper.init()` в onMounted, когда ref уже указывает на элемент.
  const swiper = new Swiper(swiperRef.value, swiperConfig.value);

  defineExpose({
    swiper,
  });

  onMounted(() => {
    swiper.init(swiperRef.value);
  });
</script>
